import {
  type PropsWithChildren,
  type ReactNode,
  useEffect,
  useState,
} from "react";
import type { PopoverTriggerProps } from "@radix-ui/react-popover";

import { Popover } from "../Popover/Popover";
import { PopoverContent } from "../Popover/Popover";
import { PopoverTrigger } from "../Popover/Popover";

import * as styles from "./InfoPopover.module.scss";

type InfoPopoverProps = PropsWithChildren<{
  content: ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  triggerProps?: PopoverTriggerProps;
}>;

const InfoPopover = ({
  children,
  content,
  open,
  onOpenChange,
  triggerProps,
}: InfoPopoverProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (typeof open === "boolean") {
      setIsOpen(open);
    }
  }, [open]);

  const handleOpenChange = (open: boolean) => {
    if (onOpenChange) {
      onOpenChange(open);
    } else {
      setIsOpen(open);
    }
  };

  return (
    <Popover
      open={typeof open === "boolean" ? open : isOpen}
      onOpenChange={handleOpenChange}
    >
      <PopoverTrigger className={styles.trigger} {...triggerProps}>
        {children}
      </PopoverTrigger>
      <PopoverContent side="top" align="center" className={styles.popOver}>
        {content}
      </PopoverContent>
    </Popover>
  );
};

InfoPopover.displayName = "InfoPopover";

export { InfoPopover };
